import React, { useState } from "react";
import "../styles/AdminDashboard.css";
import { useNavigate } from "react-router-dom";
import Register from "../Components/Register.js";
import LeaveManagement from "../Components/LeaveManagement.js";
import CreateAccount from "../Components/CreateAccount.js";
import Message from "../Components/Message.js";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { useEffect } from "react";
import Message2 from "../Components/Message2.js";
import View from "../Components/View.js";
import Location from "../Components/Location.js";
import Viewonlyhotel from "../Components/Viewonlyhotel";
import Useraccount from "../Components/Useraccount.js";
import Lregister from "../Components/Lregister.js";
import UserDashboard from "./UserDashboard.js";

const Lsadmin = () => {
  const [activeTab, setActiveTab] = useState("register");
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/"); // Redirect to login page
  };

  const renderContent = () => {
  switch (activeTab) {
    case "lregister":
      return <Lregister />;
    case "leave":
      return <LeaveManagement />;
    case "useraccount":
      return <Useraccount />;
    // case "viewonlyhotel":
    //   return <Viewonlyhotel />;
    case "location":
      return <Location />;
    // case "user":
    //   return <UserDashboard />;
    default:
      return null;
  }
};


  const useLeaveNotifications = () => {
  const [newRequests, setNewRequests] = useState([]);

  useEffect(() => {
    const q = query(collection(db, "leaveRequests"), where("status", "==", "pending"));
    const unsub = onSnapshot(q, (snapshot) => {
      const requests = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setNewRequests(requests);
    });

    return () => unsub();
  }, []);

  return newRequests;
};

  return (

    <div className="admin-background"> 
      {/* <video autoPlay muted loop className="background-video">
        <source src="/admin1.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video> */} 

      {/* Logout Button at Top-Left */} 
     

    <div className="admin-dashboard"> 
     
      <header className="admin-header"> 
        
        <nav className="admin-nav"> 

         <div className="yellow-grid">

          <button
            className={activeTab === "lregister" ? "active" : ""} 
            onClick={() => setActiveTab("lregister")} 
          >
            REGISTER
          </button>
          <button
            className={activeTab === "leave" ? "active" : ""}
            onClick={() => setActiveTab("leave")}
          >
            ROOM
          </button>
          <button
            className={activeTab === "useraccount" ? "active" : ""}
            onClick={() => setActiveTab("useraccount")}
          >
            ACCOUNT
          </button>

          <button
            className={activeTab === "location" ? "active" : ""}
            onClick={() => setActiveTab("location")}
          >
            LOCATION
          </button>

          </div>
         
        </nav>
      </header>

      <main className="admin-content">{renderContent()}</main>
    </div>
    </div>
  );
};

export default Lsadmin;
